
import AfGrupoComponent from '@/components/af/grupos/GrupoComponent'
import AfGrupoFormComponent from '@/components/af/grupos/GrupoFormComponent'

import AfMarcaComponent from '@/components/af/af_marca/AfMarcaComponent'
import AfMarcaFormComponent from '@/components/af/af_marca/AfMarcaFormComponent'

import ActivoFijoComponent from '@/components/af/activos/ActivoFijoComponent'
import ActivoFijoFormComponent from '@/components/af/activos/ActivoFijoFormComponent'

import SolicitudMttoComponent from '@/components/af/solicitudmtto/SolicitudMttoComponent'
import SolicitudMttoFormComponent from '@/components/af/solicitudmtto/SolicitudMttoFormComponent'

import MttosComponent from '@/components/af/mttos/MttosComponent'
import MttosFormComponent from '@/components/af/mttos/MttosFormComponent'

export default [{
    path: '/af/marca',
    name: 'af-marca',
    component: AfMarcaComponent,
    meta: {
        requiresAuth: true
    }
}, {
    path: '/af/marca/:id/',
    name: 'af-marca-editar',
    component: AfMarcaFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/marca-nuevo/',
    name: 'af-marca-nuevo',
    component: AfMarcaFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/grupos',
    name: 'af-grupos',
    component: AfGrupoComponent,
    meta: {
        requiresAuth: true
    }
}, {
    path: '/af/grupos/:id/',
    name: 'af-grupos-editar',
    component: AfGrupoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/grupos-nuevo/',
    name: 'af-grupos-nuevo',
    component: AfGrupoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/activos',
    name: 'af-activos',
    component: ActivoFijoComponent,
    meta: {
        requiresAuth: true
    }
}, {
    path: '/af/activos/:id',
    name: 'af-activos-editar',
    component: ActivoFijoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/activo/nuevo/',
    name: 'af-activos-nuevo',
    component: ActivoFijoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/solicitud-mtto',
    name: 'af-solicitud-mtto',
    component: SolicitudMttoComponent,
    meta: {
        requiresAuth: true
    }
}, {
    path: '/af/solicitud-mtto/:id/',
    name: 'af-solicitud-mtto-editar',
    component: SolicitudMttoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/solicitud-mtto/nuevo',
    name: 'af-solicitud-mtto-nuevo',
    component: SolicitudMttoFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/mttos',
    name: 'af-mttos',
    component: MttosComponent,
    meta: {
        requiresAuth: true
    }
}, {
    path: '/af/mttos/:id/',
    name: 'af-mttos-editar',
    component: MttosFormComponent,
    meta: {
        requiresAuth: true,
    }
}, {
    path: '/af/mttos/nuevo',
    name: 'af-mttos-nuevo',
    component: MttosFormComponent,
    meta: {
        requiresAuth: true,
    }
}, 
]